
import * as CSS from 'csstype';
import styled from 'styled-components';

export interface IPanelHeaderProps {
    height?: CSS.HeightProperty<number>;
    padding?: CSS.PaddingProperty<number>;
    justifyContent?: CSS.JustifyContentProperty;
    direction?: CSS.FlexDirectionProperty;
}

export const PanelHeader = styled.div<IPanelHeaderProps>`
    height: ${props => props.height || '60px'};
    padding: ${props => props.padding || '30px'};
    flex-direction: ${props => props.direction || 'row'};
    justify-content: ${props => props.justifyContent || 'flex-start'};
`;
